export enum AgentType {
  Agent = 'agent',
  Bot = 'bot',
}
